/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/admin/article-chart',
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/views/pages/overview/OverView.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/dashboardcc',
          name: 'dashboard',
          component: () => import('./views/DashboardAnalytics.vue'),
          meta: {
            rule: 'organization',
          }
        },
        {
          path:'/wizard',
          name:'Wizard',
          component:() => import('@/views/pages/wizard/Wizard.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path: '/user/user-info',
          name: 'user-info',
          component: () => import('./views/pages/user/UserView.vue'),
          meta: {
            rule: 'public',
          }
        },
        {
          path: '/user/user-edit',
          name: 'user-info',
          component: () => import('./views/pages/user/UserEdit.vue'),
          meta: {pageTitle: 'Sửa thông tin tài khoản',
            parent: 'user-info',
            rule: 'public',
          }
        },
        {
          path: '/user/change-password',
          name: 'change-password',
          component: () => import('./views/pages/user/UserChangePassword.vue'),
          meta: {pageTitle: 'Đổi mật khẩu',
            parent: 'user-info',
            rule: 'public',
          }
        },
        //User
        {
          path: '/admin/manage-user',
          name: 'manage-user',
          component: () => import('./views/admin-pages/user/User'),
          meta: {
            rule: 'admin',
          }
        },
        {
          path: '/admin/newspaper/manage',
          name: 'manage-newspaper',
          component: () => import('./views/admin-pages/newspaper/Newspaper'),
          meta: {
            rule: 'admin',
          }
        },
        {
          path: '/admin/newspaper/add',
          name: 'add-newspaper',
          component: () => import('./views/admin-pages/newspaper/NewspaperInformation'),
          meta: {
            pageTitle: 'Thêm Website',
            rule: 'admin',
            parent: 'manage-newspaper'
          }
        },
        {
          path: '/admin/newspaper/edit',
          name: 'edit-newspaper',
          component: () => import('./views/admin-pages/newspaper/NewspaperInformation'),
          meta: {
            pageTitle: 'Chi tiết Website',
            rule: 'admin',
            parent: 'manage-newspaper'
          }
        },
        {
          path:'/admin/admin-article',
          name:"Admin - Article",
          component: () => import('@/views/pages/article/Article.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path: '/admin/manage-user/add',
          name: 'add-user',
          component: () => import('./views/admin-pages/user/UserInformation'),
          meta: {
            pageTitle: 'Thêm tài khoản',
            parent: 'manage-user',
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-user/edit',
          name: 'edit-user',
          component: () => import('./views/admin-pages/user/UserInformation'),
          meta: {
            pageTitle: 'Sửa thông tin tài khoản',
            parent: 'manage-user',
            rule: 'admin',
          }
        },
        {
          path: "/admin/worker-manage",
          name: "manage-worker",
          component: () => import('./views/admin-pages/worker-manage/WorkerManage'),
          meta: {
            parent: "manage-worker",
            rule: "admin"
          }
        },
        {
          path: "/admin/check-config",
          name: "check-config-daily",
          component: () => import('./views/admin-pages/worker-manage/CheckConfig.vue'),
          meta: {
            parent: "check-config-dailyr",
            rule: "admin"
          }
        },

        // For sale team
        //User
        {
          path: '/contributor/manage-user',
          name: 'manage-user',
          component: () => import('./views/admin-pages/user/User'),
          meta: {
            rule: 'contributor',
          }
        },

        //Permission
        {
          path: '/admin/manage-permission',
          name: 'manage-permission',
          component: () => import('./views/admin-pages/permission/Permission'),
          meta: {
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-worker',
          name: 'manage-worker',
          component: () => import('./views/admin-pages/monitor/WorkerMonitor'),
          meta: {
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-data',
          name: 'manage-data',
          component: () => import('./views/admin-pages/monitor/DataMonitor'),
          meta: {
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-permission/add',
          name: 'add-permission',
          component: () => import('./views/admin-pages/permission/PermissionInformation'),
          meta: {
            pageTitle: 'Thêm chức năng giới hạn',
            parent: 'manage-permission',
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-permission/edit',
          name: 'edit-permission',
          component: () => import('./views/admin-pages/permission/PermissionInformation'),
          meta: {
            pageTitle: 'Sửa chức năng giới hạn',
            parent: 'manage-permission',
            rule: 'admin',
          }
        },
        // Business Package
        {
          path: '/admin/manage-package',
          name: 'manage-package',
          component: () => import('./views/admin-pages/package/Package'),
          meta: {
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-package/add',
          name: 'add-package',
          component: () => import('./views/admin-pages/package/PackageInformation'),
          meta: {
            pageTitle: 'Thêm gói dịch vụ',
            parent: 'manage-package',
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-package/edit',
          name: 'edit-package',
          component: () => import('./views/admin-pages/package/PackageInformation'),
          meta: {
            pageTitle: 'Sửa gói dịch vụ',
            parent: 'manage-package',
            rule: 'admin',
          }
        },
        {
          path: '/admin/manage-package/change-permissions',
          name: 'change-package-permission',
          component: () => import('./views/admin-pages/package/PackagePermission'),
          meta: {
            pageTitle: 'Sửa quyền gói dịch vụ',
            parent: 'manage-package',
            rule: 'admin',
          }
        },
        {
          path: '/user/topic/manage',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/topic/Topic.vue'),
          meta: {
            pageTitle: 'Quản lý chủ đề',
            rule: 'organization'
          }
        },
        {
          path: '/user/topic/manage',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/topic/Topic.vue'),
          meta: {
            pageTitle: 'Quản lý chủ đề',
            rule: 'user'
          }
        },
        {
          path: '/user/package/upgrade',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/package/PackageUpgrade.vue'),
          meta: {
            rule: 'organization',
            pageTitle:'Gia hạn gói cước'
          }
        },
        {
          path: '/user/package/upgrade',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/package/PackageUpgrade.vue'),
          meta: {
            rule: 'user'
          }
        },
        {
          path: '/user/package/manage',
          name: 'manage-package',
          component: () => import('@/views/pages/package/ManagePackage.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/package/manage',
          name: 'manage-package',
          component: () => import('@/views/pages/package/ManagePackage.vue'),
          meta: {
            rule: 'user'
          }
        },
        {
          path: '/user/trending',
          name: 'trending',
          component: () => import('@/views/pages/trending/Trending.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/detail-social-trending',
          name: 'detail-social-trending',
          component: () => import('@/views/pages/social-trending/SocialTrendingInformation.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/social-trending',
          name: 'social-trending',
          component: () => import('@/views/pages/social-trending/SocialTrending.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/statistics',
          name: 'statistics',
          component: () => import('@/views/pages/statistics/Statistics.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/data-source',
          name: 'data-source',
          component: () => import('@/views/pages/datasource/DataSource.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/topic-group',
          name: 'topic-group',
          component: () => import('@/views/pages/topicgroup/TopicGroup.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/trending',
          name: 'trending',
          component: () => import('@/views/pages/trending/Trending.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: '/user/topic/add',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/topic/TopicInformation.vue'),
          meta: {
            pageTitle: 'Thêm mới chủ đề',
            rule: 'organization'
          }
        },
        {
          path: '/user/topic/add',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/topic/TopicInformation.vue'),
          meta: {
            pageTitle: 'Thêm mới chủ đề',
            rule: 'user'
          }
        },
        {
          path: '/admin/package/manage',
          name: 'manage-package',
          component: () => import('@/views/admin-pages/package/ManagePackage.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/admin/package/approve',
          name: 'manage-package',
          component: () => import('@/views/admin-pages/package/PackageApproveInfomation.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/user/topic/edit',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/topic/TopicInformation.vue'),
          meta: {
            pageTitle: 'Cập nhật chủ đề',
            rule: 'organization'
          }
        },
        {
          path: '/user/topic/edit',
          name: 'find-by-conditions',
          component: () => import('@/views/pages/topic/TopicInformation.vue'),
          meta: {
            pageTitle: 'Cập nhật chủ đề',
            rule: 'user'
          }
        },
        {
          path:'/page/facebook/manage',
          name:'find-by-conditions',
          component: () => import('@/views/pages/facebook/FacebookManager.vue'),
          meta: {
            pageTitle: 'Quản lý Facebook',
            rule:'public'
          }
        },
        {
          path:'/page/facebook/add',
          name:'facebook-add',
          component:() => import('@/views/pages/facebook/FacebookManagerInfo.vue'),
          meta:{
            pageTitle: 'Thêm mới Facebook',
            rule:'public'
          }
        },
        {
          path:'/page/facebook/update',
          name:'facebook-edit',
          component:() => import('@/views/pages/facebook/FacebookManagerInfo.vue'),
          meta:{
            pageTitle: 'Cập nhật tài khoản Facebook',
            rule:'public'
          }
        },
        {
          path:'/page/website/manage',
          name:'website-manage',
          component: () => import('@/views/pages/manager-website/Website.vue'),
          meta:{
            pageTitle:'Quản lý Website',
            rule:'public'
          }
        },
        {
          path:'/page/website/add',
          name:'website-add',
          component: () => import('@/views/pages/manager-website/WebsiteInformation.vue'),
          meta:{
            pageTitle:'Thêm mới địa chỉ Website',
            rule:'public'
          }
        },
        {
          path:'/page/website/update',
          name:'website-update',
          component: () => import('@/views/pages/manager-website/WebsiteInformation.vue'),
          meta:{
            pageTitle:'Cập nhật địa chỉ Website',
            rule:'public'
          }
        },
        {
          path:'/user/article',
          name:'organization',
          component: () => import('@/views/pages/article/Article.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'/user/classify',
          name:'Classification Setting',
          component: () => import('@/views/pages/classification-setting/ClassificationSetting.vue'),
          meta:{
            rule:'organization',
            // pageTitle:'Quy luật dán nhãn sắc thái'
          }
        },
        {
          path:'/user/warning',
          name:'Warning',
          component: () => import('@/views/pages/warning/Warning.vue'),
          meta:{
            rule:'organization',
            pageTitle:'Quản lý cảnh báo'
          }
        },
        {
          path:'/user/warning-v2',
          name:'Warning-v2',
          component: () => import('@/views/pages/warning/Warning-v2.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'warnings'},
              { title: 'listWarnings', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/update-warning-v2',
          name:'Warning-v2',
          component: () => import('@/views/pages/warning/WarningInfomation-v2.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'warnings'},
              { title: 'warning.updateWarning', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/create-warning-v2',
          name:'Warning-v2',
          component: () => import('@/views/pages/warning/WarningInfomation-v2.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'warnings'},
              { title: 'warning.createWarning', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/warning/add',
          name:'Warning',
          component: () => import('@/views/pages/warning/WarningInformation.vue'),
          meta:{
            rule:'organization',
            pageTitle:'Thêm mới cảnh báo'
          }
        },
        {
          path:'/user/article-special',
          name: 'article-special',
          component: () => import('@/views/pages/following-article-special/FollowingArticleSpecial.vue'),
          meta:{
            rule: 'organization',
            pageTitle:'Theo dõi nguồn tin đặc biệt'
          }
        },
        {
          path:'/user/article',
          name:'article',
          component: () => import('@/views/pages/article/Article.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'/user/manager-project',
          name:'Manage',
          component: () => import('@/views/pages/manager_project/ManagerProject.vue'),
          meta:{
            rule: 'organization',
            pageTitle: 'Quản lý dự án'
          }
        },
        {
          path:'user/manage-project/data-range',
          name:'DataRange',
          component: () => import('@/views/pages/manager_project/data_range/DataRange.vue'),
          meta:{
            rule: 'organization'
          }
        },
        {
          path:'user/manage-project/list-file',
          name:'ListFile',
          component: () => import('@/views/pages/manager_project/list_file/ListFile.vue'),
          meta:{
            rule: 'organization'
          }
        },
        {
          path:'user/manage-project/list-members',
          name:'ListMembers',
          component: () => import('@/views/pages/manager_project/list_members/ListMembers.vue'),
          meta:{
            rule: 'organization'
          }
        },
        {
          path:'user/manage-project/information-service',
          name:'InformationService',
          component: () => import('@/views/pages/manager_project/information_service/InformationService.vue'),
          meta:{
            rule: 'organization'
          }
        },
        {
          path:'user/manage-project/request-widen',
          name:'InformationService',
          component: () => import('@/views/pages/manager_project/request_widen/RequestWiden.vue'),
          meta:{
            rule: 'organization'
          }
        },
        {
          path:'user/warning-manager',
          name:'Warning Manager',
          component:() => import('@/views/pages/warning/warning-manager/WarningManager.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'warnings'},
              { title: 'messageWarning', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/warning-info',
          name:'Warning Manager',
          component:() => import('@/views/pages/warning-notify/WarningNotifyInfo.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'/user/v2/project-list',
          name:'ProjectList',
          component:() => import('@/views/v2/pages/project/ProjectList.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'project'},
              { title: 'projectList', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/v2/create-new-project',
          name:'CreateNewProject',
          component:() => import('@/views/v2/pages/project/CreateNewProject.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'project'},
              { title: 'createProject', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/v2/update-project',
          name:'CreateNewProject',
          component:() => import('@/views/v2/pages/project/CreateNewProject.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'project'},
              { title: 'updateProject', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/v2/create-new-topic',
          name:'CreateNewTopic',
          component:() => import('@/views/v2/pages/project/CreateNewTopic.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'project'},
              { title: 'projectAndTopic.createNewTopic', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/user/v2/update-topic',
          name:'CreateNewTopic',
          component:() => import('@/views/v2/pages/project/CreateNewTopic.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'project'},
              { title: 'projectAndTopic.updateProject', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'/v2/pages/project/create-new-keyword',
          name:'CreateNewTopic',
          component:() => import('@/views/v2/pages/project/CreateNewKeyword.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'project'},
              { title: 'projectAndTopic.addNewKeyword', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/article-details',
          name:"Article - Details",
          component: () => import('@/views/v2/pages/article/ArticleDetail.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/article-details-v2',
          name:"Article - Details",
          component: () => import('@/views/v2/pages/article/ArticleDetail.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'news'},
              { title: 'articlesByTopic', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/article-facebook-details',
          name: "Article-facebook",
          component: () => import('@/views/pages/article/ArticleDetailFacebook.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/article-website-details',
          name: "Article-facebook",
          component: () => import('@/views/pages/article/ArticleDetailWebsite.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/article-other-details',
          name: "Article-Other",
          component: () => import('@/views/pages/article/ArticleDetailOther.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/article-topic-details',
          name: "Article-Topic",
          component: () => import('@/views/pages/article/ArticleDetailTopic.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/article-specials',
          name:'Article-special',
          component:() => import('@/views/v2/pages/article-special/ArticleSpecial.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'news'},
              { title: 'isBookMark', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/article-specials-v2',
          name:'Article-special',
          component:() => import('@/views/v2/pages/article-special/ArticleSpecial.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'news'},
              { title: 'isBookMark', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/article-spam',
          name:'Article-spam',
          component:() => import('@/views/v2/pages/article-spam/ArticleSpam.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'news'},
              { title: 'isSpam', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/article-spam-v2',
          name:'Article-spam',
          component:() => import('@/views/v2/pages/article-spam/ArticleSpam.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'news'},
              { title: 'isSpam', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/article-timeline',
          name:'Article-timeline',
          component:() => import('@/views/v2/pages/article-timeline/ArticleTimeLine.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'news'},
              { title: 'timeline', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'admin/account-data',
          name:'Account-data',
          component:() => import('@/views/pages/account-data/AccountData.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'admin/account-views',
          name:'Account-views',
          component:() => import('@/views/pages/account-data/AccountDataView.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'admin/trial-job',
          name:'Trial-job',
          component:() => import('@/views/admin-pages/trial-manage/TrialJob.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'admin/manage-topic-trial',
          name:'Trial-job',
          component:() => import('@/views/admin-pages/trial-manage/ManageTopicTrial.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'admin/trial-create-topic',
          name:'Trial-create-topic',
          component:() => import('@/views/admin-pages/trial-manage/TrialCreateTopic.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'page/trial-popup',
          name:'Trial-dashboard',
          component:() => import('@/views/v2/pages/trial/TrialPopup.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'page/trial-dashboard',
          name:'Trial-dashboard',
          component:() => import('@/views/v2/pages/trial/TrialDashboard.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'admin/trial-create-keyword',
          name:'Trial-create-keyword',
          component:() => import('@/views/admin-pages/trial-manage/TrialCreateKeyword.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'admin/account-data/update',
          name:'Account-data-update',
          component:() => import('@/views/pages/account-data/AccountData.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'admin/realtime-chart',
          name:'Realtime-Chart',
          component:()  => import('@/views/pages/realtime-chart/RealtimeChart.vue'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'user/export-file',
          name:'Export-file',
          component:() => import('@/views/pages/export-file/ExportFile.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/manager-notification-message',
          name:'Notify-message',
          component:() => import('@/views/pages/manager-notification-message/ManagerNotificationMessage.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/manager-keyword',
          name:'Manager-keyword',
          component:() => import('@/views/pages/manager-keyword/ManagerKeyword.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/compare-branding',
          name:'Compare-branding',
          component:() => import('@/views/v2/pages/compare-branding/CompareBranding.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/compare-branding-v2',
          name:'Compare-branding',
          component:() => import('@/views/v2/pages/compare-branding/CompareBranding.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/account-user',
          name:'Account-user',
          component:() => import('@/views/pages/account-user/AccountUser.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/account-user-info',
          name:'Account-info',
          component:() => import('@/views/pages/account-user/AccountUserInformation.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/setting-general',
          name:'GeneralSettings',
          component:() => import('@/views/v2/pages/generalSettings/GeneralSettings.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'setting'},
              { title: 'generalSetting', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/setting-rules',
          name:'Rules',
          component:() => import('@/views/v2/pages/generalSettings/Rules.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/classify-source',
          name:'Classify-source',
          component:() => import('@/views/pages/classify-source/ClassifySource.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/classify-source-details',
          name:'Classify-source-details',
          component:() => import('@/views/pages/classify-source/ClassifySourceInfomation.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path:'user/notify',
          name:'Register-Notify',
          component:() => import('@/views/pages/manager-register-notify/RegisterNotify.vue'),
          meta:{
            rule:'organization'
          }
        },
        {
          path: 'user/package-detail',
          name: 'Package-Detail',
          component: () => import('@/views/pages/manager_project/information_service/InformationService.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: 'user/dashboard-v2',
          name: 'Dashboard',
          component: () => import('@/views/DashboardAnalytics-v2.vue'),
          meta:{
            rule: 'organization'
          }
        },
        {
          path: 'user/account-overview',
          name: 'Account overview',
          component: () => import('@/views/pages/account-overview/AccountOverview.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: 'user/special-info',
          name: 'Special-Infomation',
          component: () => import('@/views/pages/overview/special-infomation/SpecialInfomation.vue'),
          meta: {
            rule: 'organization'
          }
        },
        {
          path: 'user/source-article',
          name: 'Source Article',
          component: () => import('@/views/pages/manager-website/Website-v2.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'sourceData'},
              { title: 'listSourceWebsite', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path: 'user/source-facebook',
          name: 'Source-Facebook',
          component: () => import('@/views/pages/facebook/FacebookManager-v2.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'sourceData'},
              { title: 'listSourceFb', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path: 'user/package-upgrade-v2',
          name: 'Package-data',
          component: () => import('@/views/pages/package/PackageUpgrade-v2.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'settings'},
              { title: 'packageData', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/personal-account-v2',
          name:'personal-account',
          component:() => import('@/views/v2/pages/account/PersonnalAccount.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'settings'},
              { title: 'personalAccount', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/group-account-v2',
          name:'group-account',
          component:() => import('@/views/v2/pages/account/GroupAccount.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'settings'},
              { title: 'groupAccount', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/v2/export-file',
          name:"Export-file",
          component: () => import('@/views/v2/pages/export-file/ExportFile.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'report'},
              { title: 'exportFile.exportReport', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/v2/report-calendar',
          name:"report-calendar",
          component: () => import('@/views/v2/pages/export-file/ReportCalendar.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'report'},
              { title: 'reportCalendar', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/v2/report-calendar-update',
          name:"report-calendar",
          component: () => import('@/views/v2/pages/export-file/ReportCalendar.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'report'},
              { title: 'reportCalendarUpdate', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/v2/report-list',
          name:"report-list",
          component: () => import('@/views/v2/pages/export-file/ReportList.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'report'},
              { title: 'reportList', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/v2/report-calendar-list',
          name:"report-calendar-list",
          component: () => import('@/views/v2/pages/export-file/ReportCalendarList.vue'),
          meta:{
            breadcrumb: [
              { title: 'dashboard', url: '/' },
              { title: 'report'},
              { title: 'reportCalendarList', active: true}
            ],
            rule:'organization',
          }
        },
        {
          path:'user/v2/package-register',
          name:"report-calendar-list",
          component: () => import('@/views/v2/pages/package-data/PackageRegister.vue'),
          meta:{
            rule:'organization',
          }
        },
        {
          path:'user/v2/invoice',
          name:"report-calendar-list",
          component: () => import('@/views/v2/pages/package-data/Invoice.vue'),
          meta:{
            rule:'organization',
          }
        },
        {
          path:'user/v2/invoice-info',
          name:"report-calendar-list",
          component: () => import('@/views/v2/pages/package-data/InvoiceInfomation.vue'),
          meta:{
            rule:'organization',
          }
        },
        {
          path:'user/v2/share-of-voice',
          name:"Share of voice",
          component: () => import('@/views/v2/pages/share-of-voice/ShareOfVoice.vue'),
          meta:{
            rule:'organization',
          }
        },
        {
          path:'user/v2/hashtag',
          name:"Hashtag",
          component: () => import('@/views/v2/pages/hashtag/Hashtag.vue'),
          meta:{
            rule:'organization',
          }
        },
        {
          path:'user/v2/demo-graphic',
          name:"Demo graphic",
          component: () => import('@/views/v2/pages/demo-graphic/DemoGraphic.vue'),
          meta:{
            rule:'organization',
          }
        },
        {
          path:'admin/widget',
          name:"Widget Manager",
          component: () => import('@/views/pages/widget/WidgetManager.vue'),
          meta:{
            rule:'admin',
          }
        },
        {
          path:'admin/widget-create',
          name:"Widget Infomation",
          component: () => import('@/views/pages/widget/widget-infomation/WidgetInfomation.vue'),
          meta:{
            rule:'admin',
          }
        },
        {
          path:'admin/widget-update',
          name:"Widget Infomation",
          component: () => import('@/views/pages/widget/widget-infomation/WidgetInfomation.vue'),
          meta:{
            rule:'admin',
          }
        },
        {
          path:'/admin/spread-article',
          name:"Admin - The spread of the article",
          component: () => import('@/views/pages/article/ArticleSpread'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'/admin/article-chart',
          name:"Article chart",
          component: () => import('@/views/pages/article/ArticleChart'),
          meta:{
            rule:'admin'
          }
        },
        {
          path:'/admin/article-spread-table',
          name:"Article spread table",
          component: () => import('@/views/pages/article/ArticleSpreadTable'),
          meta:{
            rule:'admin'
          }
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/request-demo',
          name: 'page-request-demo',
          component: () => import('@/views/pages/RequestDemo.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/active',
          name: 'page-active',
          component: () => import('@/views/v2/pages/login/ActiveAccountNew.vue'),
          meta: {
            rule: 'public'
          }
        },
        // {
        //   path: '/pages/login',
        //   name: 'page-login',
        //   component: () => import('@/views/pages/Login.vue'),
        //   meta: {
        //     rule: 'public'
        //   }
        // },
        {
          path: '/pages/send-email-forgot-password',
          name: 'page-send-forgot-forgot-password',
          component: () => import('@/views/v2/pages/login/SendEmailForgotPasswordNewUI.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-send-forgot-forgot-password',
          component: () => import('@/views/v2/pages/login/ForgotPasswordNew.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/v2/pages/login/Login'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/create-new-account',
          name: 'create-new-account',
          component: () => import('@/views/v2/pages/login/CreateNewAccountNew.vue'),
          meta: {
            rule: 'public'
          }
        },
        // {
        //   path: '/pages/login-v2',
        //   name: 'page-login',
        //   component: () => import('@/views/v2/pages/login/LoginNewUI.vue'),
        //   meta: {
        //     rule: 'public'
        //   }
        // },
        {
          path: '/pages/login-ui/trial',
          name: 'request-trial',
          component: () => import('@/views/pages/login/RequestTrial.vue'),
          meta: {
            rule: 'public'
          }
        },

        //============Common page========
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'public'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  const html = document.getElementsByTagName('html')[0];

  if (appLoading) {
    appLoading.style.display = "none";
    html.style.overflow = "initial";
  }
});

export default router
